<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="scss">
</style>

<script>
console.log("app.vue");
</script>
<style >
html,
body,
#app {
  height: 100%;
  user-select: none;
}
</style>
